import type { FC } from 'react';
import type { CyberIQBadge } from '../../../apiHooks/useCyberIQBadgesQuery';
import styled from 'styled-components';
import { NamedContentEntryText } from '../../ContentEntryText/NamedContentEntryText';

type BadgeTooltipProps = {
  badge: CyberIQBadge;
};

export const BadgeTooltip: FC<BadgeTooltipProps> = ({ badge }: BadgeTooltipProps) => {
  const titleKey = `${badge.id}Title` as never;
  const descriptionKey = `${badge.id}Description` as never;

  return (
    <TooltipContainer>
      <BadgeName>
        <NamedContentEntryText refKey="badges" container="span" subKey={titleKey} />
      </BadgeName>
      <BadgeDescription>
        <NamedContentEntryText refKey="badges" container="span" subKey={descriptionKey} />
      </BadgeDescription>
    </TooltipContainer>
  );
};

const TooltipContainer = styled.div`
  width: max-content;
  max-width: 320px;
  padding: 8px 12px;
  outline: 1px solid ${({ theme }) => theme.colors.prototype.border};
  border-radius: 8px;
  box-shadow: ${({ theme }) => theme.shadow.light};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background-color: ${({ theme }) => theme.colors.prototype.background};
`;

const BadgeName = styled.span`
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSizes.normal};
  color: ${({ theme }) => theme.colors.prototype.foreground};
`;

const BadgeDescription = styled.span`
  font-weight: 400;
  font-size: ${({ theme }) => theme.fontSizes.normal};
  color: ${({ theme }) => theme.colors.prototype.mutedForeground};
`;
